export default __webpack_public_path__ + "static/media/home.a06166d4.png";